import {
	BIRTH_NUMBER_MAX_LENGTH,
	BIRTH_NUMBER_MIN_LENGTH,
	BIRTH_NUMBER_DIVISOR,
} from '../../../const/zod/zod';
import { validateBirthNumber } from '../../../helpers/validateBirthNumber/validateBirthNumber';

import type { BirthNumberValidationParams } from './types/types';

export const getBirthNumberErrorMessage = ({
	value,
	numberErrorText,
	noSlashText,
	getBirthNumberRemainderText,
	birthNumberInvalidText,
	getBirthNumberLengthText,
}: BirthNumberValidationParams) => {
	if (!value) return undefined;

	const validationResult = validateBirthNumber(value);

	if (validationResult.isValid) {
		return undefined;
	}

	if (validationResult.errors.hasSlash) {
		return noSlashText;
	}

	if (validationResult.errors.invalidLength) {
		return getBirthNumberLengthText({
			minBirthNumberLength: BIRTH_NUMBER_MIN_LENGTH,
			maxBirthNumberLength: BIRTH_NUMBER_MAX_LENGTH,
		});
	}

	if (validationResult.errors.invalidFormat) {
		return numberErrorText;
	}

	if (validationResult.errors.invalidControlDigit) {
		return getBirthNumberRemainderText({ number: BIRTH_NUMBER_DIVISOR });
	}

	if (validationResult.errors.invalidBirthDate) {
		return birthNumberInvalidText;
	}

	return undefined;
};
